import gsap from 'gsap'
import barba from '@barba/core'
import { smoothScroller, snapToTop } from './smoothScroller.js'
import { navigation } from './navigation.js'
import { animation } from './animation.js'
import { swiper } from './swiper.js'
import { cursor, reset } from './cursor.js'
import { quickbar } from './quickbar.js'
import { matchHeight } from './match-height.js'
import { refreshScripts } from './utilities.js'

const initBarba = () => {

	barba.init({
		debug: false,
		schema: {
			prefix: 'data-load',
		},
		prevent: ({ el }) => el.classList.contains('ab-item'),
		prevent: ({ href }) => href.includes('schedule') || href.includes('contact'),
		transitions: [{
			name: 'basic-transition',
			once(data) {
				setTimeout(() => {
					snapToTop()
				}, 500);
				setTimeout(() => {
					document.body.dataset.preloader = 'in-progress'
				}, 100);
				setTimeout(() => {
					document.body.dataset.preloader = 'complete'
				}, 1800);
			},
			leave(data) {
				document.body.removeAttribute('data-navigation-status')
				const done = this.async()
				setTimeout(function () {
					done()
				}, 800)
				return gsap.to(data.current.container, { duration: 0.3, opacity: 0 })
			},
			after(data) {
				snapToTop()
				return gsap.from(data.next.container, { duration: 0.3, opacity: 0 })
			}
		}]
	})

	barba.hooks.once((data) => {
		smoothScroller()
		navigation()
		setTimeout(() => animation(), 1800);
		swiper()
		// cursor()
		quickbar()
	})

	barba.hooks.after((data) => {
		// reset()
		smoothScroller()
		animation()
		swiper()
		matchHeight()
		quickbar()
		refreshScripts(data.next.container)

		gtag('event', 'page_view', {
			'page_title': document.title,
			'page_location': location.href,
			'page_path': location.pathname,
		})
	})

}

export default initBarba